import { createAjaxClient, safeApiCall } from '@/shared/utils/apiHelper';
import { mapResponse } from './mappers';
import { ApiSuccessResponse, ApiErrorResponse } from '@/shared/types/api.types';
import type { Cookies } from '../models';
import type { CheckCookieResponse } from './responses';

/**
 * Check the cookie.
 *
 * @returns {Promise<ApiSuccessResponse<Cookies>>} The check cookie response.
 * @throws {ApiErrorResponse} If the API call fails.
 */
export async function checkCookie(): Promise<ApiSuccessResponse<Cookies>> {
    const ajaxClient = createAjaxClient();

    const result = await safeApiCall<CheckCookieResponse>(
        ajaxClient('/CX/scr-login2.php', {
            method: 'POST',
            credentials: 'include',
            query: {
                action: 'check_cookie'
            },
        }),
    );

    if (result instanceof ApiErrorResponse) {
        throw result;
    }

    return mapResponse(result.data);
}
